import { type App, defineAsyncComponent } from 'vue'

const components = {
  ChatActivity: defineAsyncComponent(() => import('./ChatActivity.vue')),
  ChatComposer: defineAsyncComponent(() => import('./ChatComposer.vue')),
  ChatDisclosure: defineAsyncComponent(() => import('./ChatDisclosure.vue')),
  ChatImages: defineAsyncComponent(() => import('./ChatImages.vue')),
  ChatLoader: defineAsyncComponent(() => import('./ChatLoader.vue')),
  ChatSaid: defineAsyncComponent(() => import('./ChatSaid.vue')),
  ChatShell: defineAsyncComponent(() => import('./ChatShell.vue')),
  ChatTurn: defineAsyncComponent(() => import('./ChatTurn.vue')),
  ChatVoiceCard: defineAsyncComponent(() => import('./ChatVoiceCard.vue')),
  ChatVoiceDrawer: defineAsyncComponent(() => import('./ChatVoiceDrawer.vue')),
  ChatVoiceShown: defineAsyncComponent(() => import('./ChatVoiceShown.vue')),
  ChatVoiceView: defineAsyncComponent(() => import('./ChatVoiceView.vue'))
}

type Registry = typeof components

declare module 'vue' {
  interface GlobalComponents extends Registry {}
}

export const registerComponents = (app: App) => {
  for (const [name, component] of Object.entries(components)) {
    app.component(name, component)
  }
}
